export const Permission = {
    read: 'read',
    write: 'write' 
};


// root admin
export const isAdmin = (userType) => {
    return (userType && userType === 'admin');
}

export const isPluginAdmin = (userType) => {
    return isAdmin(userType) || (userType && userType === 'plugin_admin');
}

const hasScope = (scopes, requiredScope) => {

    if (typeof scopes === 'string') {
        const list = scopes.split(' ');
        return list.includes(requiredScope);

    } else {
        return false;
    }

}

export const hasPluginPermission = (userType, scopes, requiredPermission) => {

    const requiredScope = `$plugin_${requiredPermission}`

    if (isAdmin(userType)) {
        return true;
    } else if ( isPluginAdmin(userType) && hasScope(scopes, requiredScope) ) {
        return true;
    }

    return false;
}
